/*
  age-gate.js — Edible Growth Shopify Theme
  Port of AgeGate.jsx localStorage check + overlay logic.

  On page load: checks localStorage for 'ageVerified'.
  If absent → shows the overlay (which blocks scrolling).
  "I am 21+" → sets localStorage, hides overlay.
  "I am under 21" → redirects to google.com.
*/

(function () {
  'use strict';

  function init() {
    var gate      = document.getElementById('eg-age-gate');
    var confirmBtn = document.getElementById('eg-age-confirm');
    var denyBtn    = document.getElementById('eg-age-deny');

    if (!gate) return;

    var isVerified = localStorage.getItem('ageVerified');

    if (isVerified === 'true') {
      /* Already verified — hide immediately with no transition */
      gate.style.display = 'none';
      return;
    }

    /* Show the gate and prevent scroll */
    gate.classList.remove('is-hidden');
    document.body.style.overflow = 'hidden';

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        localStorage.setItem('ageVerified', 'true');
        gate.classList.add('is-hidden');
        document.body.style.overflow = '';

        /* Remove from DOM after CSS transition ends */
        gate.addEventListener('transitionend', function () {
          gate.style.display = 'none';
        }, { once: true });
      });
    }

    if (denyBtn) {
      denyBtn.addEventListener('click', function () {
        window.location.href = 'https://www.google.com';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
